import { ErrorPayload } from '../types';

export function isErrorPayload(val: any): val is ErrorPayload {
  return !!val?.error;
}
